/**
 * Auth
 */
export const GET_SMS_CODE = '/1.0/users/getSmsCode'
export const LOGIN_WITH_PHONE = '/1.0/users/mixLoginWithPhone'
export const LOGIN_WITH_PASSWORD = '/1.0/users/login'
export const CREATE_SESSION = '/sessions.create'
export const CONFIRM_SESSION = '/sessions.wait_for_confirmation'
export const REFRESH_TOKEN = '/app_auth_tokens.refresh'

/**
 * User
 */
export const USER_PROFILE = '/1.0/users/profile'
export const FOLLOW_USER = '/1.0/userRelation/follow'
export const UNFOLLOW_USER = '/1.0/userRelation/unfollow'
export const FOLLOWING_LIST = '/1.0/userRelation/getFollowingList'
export const FOLLOWER_LIST = '/1.0/userRelation/getFollowerList'

/**
 * Post
 */
export const LIST_FOLLOWING_POSTS = '/1.0/personalUpdate/followingUpdates'
export const LIST_RECOMMEND_POSTS = '/1.0/recommendFeed/list'
export const LIST_USER_POSTS = '/1.0/personalUpdate/single'
export const LIKE_POST = '/1.0/originalPosts/like'
export const LIKE_REPOST = '/1.0/reposts/like'
export const UNLIKE_POST = '/1.0/originalPosts/unlike'
export const UNLIKE_REPOST = '/1.0/reposts/unlike'
export const CREATE_POST = '/1.0/originalPosts/create'
export const EDIT_POST = '/1.0/originalPosts/edit'
export const REPOST = '/1.0/reposts/add'
export const EDIT_REPOST = '/1.0/reposts/edit'
export const GET_POST = '/1.0/originalPosts/get'
export const GET_REPOST = '/1.0/reposts/get'
export const COLLECT_POST = '/1.0/originalPosts/collect'
export const UNCOLLECT_POST = '/1.0/originalPosts/uncollect'
export const COLLECT_REPOST = '/1.0/reposts/collect'
export const UNCOLLECT_REPOST = '/1.0/reposts/uncollect'
export const LIST_COLLETIONS = '/1.0/collections/list'
export const DELETE_POST = '/1.0/originalPosts/remove'
export const DELETE_REPOST = '/1.0/reposts/remove'
export const PIN_POST = '/1.0/personalUpdate/pin'
export const UNPIN_POST = '/1.0/personalUpdate/unpin'
export const SPONSOR_HIDE_POST = '/1.0/originalPosts/sponsor/hide'
export const SPONSOR_RECOVER_POST = '/1.0/originalPosts/sponsor/recover'
export const SPONSOR_HIDE_REPOST = '/1.0/reposts/sponsor/hide'
export const SPONSOR_RECOVER_REPOST = '/1.0/reposts/sponsor/recover'

/**
 * Comment
 */
export const LIST_COMMENTS = '/1.0/comments/list'
export const LIST_PRIMARY_COMMENTS = '/1.0/comments/listPrimary'
export const ADD_COMMENT = '/1.0/comments/add'
export const LIKE_COMMENT = '/1.0/comments/like'
export const UNLIKE_COMMENT = '/1.0/comments/unlike'
export const GET_COMMENT = '/1.0/comments/get'
export const PIN_COMMENT = '/1.0/comments/pin'
export const UNPIN_COMMENT = '/1.0/comments/unpin'
export const DELETE_COMMENT = '/1.0/comments/remove'

/**
 * Topic
 */
export const LIST_DRAFT_SUGGESTIONS = '/1.0/originalPosts/listDraftSuggestions'
export const SEARCH_TOPIC = '/1.0/users/topics/search'
export const TOPIC_DETAIL = '/1.0/topics/getDetail'
export const TOPIC_FEED = '/1.0/topics/tabs/:tab/feed'
export const CHANGE_TOPIC_SUBSCRIPTION_STATUS = '/1.0/users/topics/changeSubscriptionStatus'
export const LIST_TOPPING_SHORTCUTS = '/1.0/shortcuts/listTopping'
export const LIST_SUBSCRIBED_TOPICS = '/1.0/topics/listSubscribed'
export const ADD_TOPPING_SHORTCUT_TOPIC = '/1.0/shortcuts/management/topic/add'
export const REMOVE_TOPPING_SHORTCUT_TOPIC = '/1.0/shortcuts/management/topic/remove'

/**
 * Notification
 */
export const LIST_NOTIFICATIONS = '/1.0/notifications/list'
export const UNREAD_NOTIFICATION_COUNT = '/1.0/notifications/unread'

/**
 * Other
 */
export const READABILITY_EXTRACT = '/1.0/readability/extract'
export const MEDIA_META = '/1.0/mediaMeta/interactive'
export const MANIFESTS = '/1.0/manifests/getBase'
export const SEARCH = '/1.0/search/integrate'
export const RELATED_KEYWORD_TIP = '/1.0/related/keywordTip'
export const LIST_MENTIONS = '/1.0/mentions/listMentionUsers'
export const MENTIONS_SEARCH_USER = '/1.0/mentions/searchUser'
export const APP_GET = '/1.0/configs/appGet'

export const SHORT_LINK = 'https://url.ruguoapp.com/1.0/shortUrl/shorten'
